import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5","key":"svg-0"}]]

const IconRotateClockwise = createReactComponent('outline', 'rotate-clockwise', 'RotateClockwise', __iconNode);

export default IconRotateClockwise;